<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="learning-path-deadlines"
            :items="tableData"
            :fields="deadlineFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-lp-deadline"
                    v-b-modal="'create-lp-deadline-modal'"
                    type="button"
                    label="creat-new-lp-deadline"
                    variant="primary">
                    {{ $t('learning_path.add_period') }}
                </b-button>
            </template>

            <template v-slot:cell(start)="data">
                {{ data.item.start | date_time_om }}
            </template>
            <template v-slot:cell(deadline)="data">
                {{ data.item.deadline | date_time_om }}
            </template>

            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-open btn-open-lp-deadline-series"
                        v-b-tooltip.hoover
                        :title="$t('common.open')"
                        variant="primary-icon-only"
                        @click="openDeadline(data.item.id)">
                    </b-button>
                    <b-button
                        class="btn-edit btn-edit-lp-deadline"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="openEditDeadline(data.item.id)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-lp-deadline"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeDeadline(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-create-learning-path-deadline-modal
            :lp-deadline-series-in="lpDeadlineSeriesIn"
            :lp-assignments-in="lpAssignmentsIn"
            @createDeadline="createDeadline($event)"
            ref="create-lp-deadline-modal">
        </design-2021-create-learning-path-deadline-modal>
        <design-2021-update-learning-path-deadline-modal
            :lp-assignments-in="lpAssignmentsIn"
            @updateDeadline="updateDeadline($event)"
            ref="update-lp-deadline-modal">
        </design-2021-update-learning-path-deadline-modal>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'design-2021-learning-path-deadline-index-component',
    props: ['lpDeadlineSeriesIn', 'lpAssignmentsIn'],
    data() {
        return {
            lpDeadlineSeries: this.lpDeadlineSeriesIn,
            lpDeadlines: this.lpDeadlineSeriesIn.lp_deadlines,
            deadlineFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'start',
                    label: 'Start',
                },
                {
                    key: 'deadline',
                    label: 'Deadline',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            let data = this.lpDeadlines.map((deadline) => {
                const newDate = new Date(deadline.deadline);
                return {
                    id: deadline.id,
                    name: deadline.name,
                    start: moment(deadline.start).format('YYYY-MM-DD HH:mm'),
                    deadline: moment(deadline.deadline).format('YYYY-MM-DD HH:mm'),
                    dateObject: newDate,
                };
            });
            return data.sort((objA, objB) => Number(objA.dateObject) - Number(objB.dateObject));
        },
    },
    methods: {
        createDeadline(data) {
            this.lpDeadlines.push(data);
            this.alert.success();
        },
        openEditDeadline(deadlineId) {
            const deadline = this.lpDeadlines.find((deadline) => deadline.id === deadlineId);
            this.$refs['update-lp-deadline-modal'].show(deadline);
        },
        updateDeadline(data) {
            this.lpDeadlines = this.lpDeadlines.map((deadline) => {
                return deadline.id === data.id ? data : deadline;
            });
            this.alert.success();
        },
        removeDeadline(id) {
            this.alert
                .confirm(
                    this.$t('learning_path.delete_deadline'),
                    this.$t('learning_path.are_you_sure_you_want_to_delete_this_deadline'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.removeLpDeadline(id)).then(
                        (response) => {
                            this.lpDeadlines = this.lpDeadlines.filter((item) => item.id !== id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        openDeadline(id) {
            window.location.href = this.routes.lpManagementDeadline(this.lpDeadlineSeries.id, id);
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    .btn {
        &:before {
            margin-right: 0;
        }
    }
}
</style>
